import { useMemo } from 'react';
import useFetch from "./useFetch";

function useSequences(params) {
    
    const url = useMemo(() => {
        const query_params = new URLSearchParams(Object.entries(params).sort()).toString();
        return `/api/sequences/${query_params ? `?${query_params}` : ''}`;
    }, [params]);
    const { data, ...rest } = useFetch(url);
    const sequences = data ? data["data"] : null
    const nextCursor = data ? data["next_cursor"] : 0
    const prevCursor = data ? data["prev_cursor"] : 0
    const totalCount = data ? data["total_count"] : 0

    return { sequences, nextCursor, prevCursor, totalCount, ...rest };

};

export default useSequences;